import { fromJS } from 'immutable';

import consentMessages from '../consent/consentMessages';
import { ACCEPTED_GDPR_TERMS_AGREEMENT } from '../consent/consentModule';



export const validateGDPRTermsConsentGiven = (isEnabled, format) => (
    (isGiven) => {
        if (isEnabled && format === 'EXPLICIT' && !isGiven) {
            return consentMessages.uncheckedTermsAcknowledgementMessage;
        }

        return undefined;
    }
);


const getGDPRFieldConstraints = (
    isGdprTermsAcknowledgementEnabled,
    gdprTermsAcknowledgementFormat
) => (
    fromJS({
        [ACCEPTED_GDPR_TERMS_AGREEMENT]: [
            validateGDPRTermsConsentGiven(isGdprTermsAcknowledgementEnabled, gdprTermsAcknowledgementFormat)
        ]
    })
);

export default getGDPRFieldConstraints;
